import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/water-activities',
    name: 'WaterActivities',
    component: () => import(/* webpackChunkName: "WaterActivities" */ '../views/WaterActivities.vue')
  },
  {
    path: '/water-activities/:id',
    name: 'WaterActivity',
    component: () => import(/* webpackChunkName: "WaterActivity" */ '../views/Activity.vue')
  },
  {
    path: '/land-activities',
    name: 'LandActivities',
    component: () => import(/* webpackChunkName: "LandActivities" */ '../views/LandActivities.vue')
  },
  {
    path: '/land-activities/:id',
    name: 'LandActivity',
    component: () => import(/* webpackChunkName: "LandActivity" */ '../views/Activity.vue')
  },
  {
    path: '/team-building',
    name: 'TeamBuilding',
    component: () => import(/* webpackChunkName: "TeamBuilding" */ '../views/TeamBuilding.vue')
  },
  {
    path: '/team-building/:id',
    name: 'TeamBuildingActivity',
    component: () => import(/* webpackChunkName: "TeamBuildingActivity" */ '../views/Activity.vue')
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: () => import(/* webpackChunkName: "AboutUs" */ '../views/AboutUs.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "Contact" */ '../views/Contact.vue')
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import(/* webpackChunkName: "Gallery" */ '../views/Gallery.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.afterEach((to) => {
  //@ts-expect-error gtag is global var in index.html
  gtag('config', 'UA-163213809-1', {
    page_path: to.fullPath,
    app_name: 'Waiheke Adventure Centre',
    send_page_view: true,
  });
});


export default router
